(() => {
class CraiaFeaturedPiecesRail {
  constructor(section) {
    this.section = section;
    this.rail = section.querySelector('[data-craia-product-rail]');
    this.previous = section.querySelector('[data-craia-rail-previous]');
    this.next = section.querySelector('[data-craia-rail-next]');

    if (!this.rail || !this.previous || !this.next) return;

    this.movePrevious = () => this.move(-1);
    this.moveNext = () => this.move(1);
    this.updateControls = () => this.update();

    this.previous.addEventListener('click', this.movePrevious);
    this.next.addEventListener('click', this.moveNext);
    this.rail.addEventListener('scroll', this.updateControls, { passive: true });
    window.addEventListener('resize', this.updateControls);
    requestAnimationFrame(this.updateControls);
  }

  move(direction) {
    const card = this.rail.querySelector('.craia-featured-pieces__card');
    if (!card) return;

    const styles = window.getComputedStyle(this.rail);
    const gap = Number.parseFloat(styles.columnGap) || 0;
    const distance = card.getBoundingClientRect().width + gap;

    this.rail.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  update() {
    const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    this.previous.disabled = this.rail.scrollLeft <= 2;
    this.next.disabled = this.rail.scrollLeft >= maximum - 2;
  }
}

const initializeCraiaFeaturedPieces = (scope = document) => {
  scope.querySelectorAll('.craia-featured-pieces').forEach((section) => {
    if (section.dataset.craiaRailReady === 'true') return;
    section.dataset.craiaRailReady = 'true';
    new CraiaFeaturedPiecesRail(section);
  });
};

initializeCraiaFeaturedPieces();
document.addEventListener('shopify:section:load', (event) => initializeCraiaFeaturedPieces(event.target));
})();
